import { BrowserRouter } from "react-router-dom"
import { Suspense } from "react"
import { PageLoader } from "src/shared/components"
import Routes from "src/routes"
import useCustomHotkeys from "src/shared/hotkeys/shortcuts"
import AuthProvider from "./shared/store/slices/auth/auth-provider"
import MaintenanceProvider from "./shared/maintenance/MaintenanceProvider"

function App() {
  useCustomHotkeys()
  console.log("VITE_REACT_APP_ENV", import.meta.env)
  return (
    <Suspense fallback={<PageLoader isLoading={true} />}>
      <MaintenanceProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </AuthProvider>
      </MaintenanceProvider>
    </Suspense>
  )
}

export default App
